import { TransactionState } from './types'

export * from './computeState'
export * from './generateIntervalActions'
export * from './mapTransactions'
export * from './processTransactions'
export * from './sortTransactions'
export * from './types'
export * from './calculateRequiredPayment'
export * from './calculatePayedInterest'

export const initialState: TransactionState = {
  amount: 0,
  interest: 0,
  latestUpdate: null,
  loanedAmount: 0,
  closedOn: null,
  createdOn: null
}



// WEBPACK FOOTER //
// ./src/utils/transactions/index.tsx